/** Integer minor units (kopecks). Never use floating-point money. */

export type MinorUnits = bigint;

export function rubToKopecks(rubles: number): MinorUnits {
  if (!Number.isInteger(rubles) || rubles < 0) {
    throw new Error("rubles must be a non-negative integer");
  }
  return BigInt(rubles) * 100n;
}

export function formatRub(kopecks: MinorUnits): string {
  const negative = kopecks < 0n;
  const abs = negative ? -kopecks : kopecks;
  const whole = abs / 100n;
  const frac = abs % 100n;
  const body = frac === 0n ? `${whole}` : `${whole},${frac.toString().padStart(2, "0")}`;
  return `${negative ? "−" : ""}${body} ₽`;
}

/** Half-up rounding for commission: platform_fee = floor((gross * rate_bps + 5000) / 10000) */
export function platformFee(gross: MinorUnits, rateBps: number): MinorUnits {
  if (gross <= 0n) return 0n;
  const rate = BigInt(rateBps);
  return (gross * rate + 5000n) / 10000n;
}

export function splitCommission(
  gross: MinorUnits,
  rateBps = 2000,
): { platformFee: MinorUnits; sellerNet: MinorUnits } {
  const fee = platformFee(gross, rateBps);
  return { platformFee: fee, sellerNet: gross - fee };
}
